"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PickupPointsListPage = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useFindPickupPointsQuery = require("../../api/useFindPickupPointsQuery");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _DeliveryBox = _interopRequireDefault(require("../DeliveryBox/DeliveryBox"));
var _FormattedMessage = require("../FormattedMessage");
var _Skeleton = require("../Skeleton");
var _shared = require("../shared");
var _FindPickupPointsSearchMessage = require("./FindPickupPointsSearchMessage");
var _NoResultsMessage = require("./NoResultsMessage");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-no-leaked-render -- checked */

const componentName = 'PickupPointsListPage.tsx';

// TODO: Refactor to remove unnecessary prop and solve with css
const Root = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isLastPage
  }
}) => ({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'start',
  padding: theme.spacing(0, 3),
  paddingBottom: isLastPage ? theme.spacing(3) : 0,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 6),
    paddingBottom: isLastPage ? theme.spacing(6) : 0
  }
}));

// TODO: Refactor to remove unnecessary prop and solve with css
const ResultsHeader = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isMapAvailable
  }
}) => ({
  marginBottom: theme.spacing(3),
  marginTop: theme.spacing(3),
  ...(isMapAvailable && {
    marginTop: theme.spacing(5)
  })
}));
const ResultsLabel = (0, _mui.styled)(_mui.Typography)(() => (0, _shared.lineClampStyles)(2));
const ContentWrapper = (0, _mui.styled)('div')({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  height: '100%'
});
const LoadMore = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  display: 'block',
  margin: '0 auto',
  marginTop: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(8)
  }
}));

/**
 * @obsolete Can be dropped later when flat selection UI is used in all markets
 * and/or the merged map & list UI switch is enabled everywhere.
 */
const PickupPointsListPage = ({
  activeFilter,
  currentListPage,
  isMapAvailable,
  onPickupPointItemConfirmation,
  pageKey,
  pageNumber,
  searchTerm,
  showMorePickupPoints
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    isAddingNewDelivery
  } = (0, _hooks.useAnalytics)();
  const isFirstPage = pageNumber === 0;
  const isLastPage = pageNumber === currentListPage;
  const {
    foundPlaceLabel,
    isLoadMoreVisible,
    isPickupPointsListLoading,
    pickupPointsList,
    pickupPointsListError
  } = (0, _useFindPickupPointsQuery.useFindPickupPointsQuery)({
    activeFilter,
    isMapEnabled: isMapAvailable,
    page: pageNumber,
    searchTerm
  });
  const isError = !isPickupPointsListLoading && Boolean(pickupPointsListError);
  const isFindMessageVisible = isFirstPage && !isError && !isPickupPointsListLoading && !searchTerm;
  const isContentWrapperVisible = !isPickupPointsListLoading && Boolean(searchTerm) && Boolean(pickupPointsList);
  const isNoResultsVisible = isFirstPage && isContentWrapperVisible && pickupPointsList?.length === 0;
  const resultsLabel = foundPlaceLabel ? `${formatMessage('resultsNearby')} “${foundPlaceLabel}”` : formatMessage('results');
  (0, _logger.logDebug)(`Rendering ${componentName} ...\n\tlocal vars:`, {
    currentListPage,
    isError,
    isFindMessageVisible,
    isFirstPage,
    isLastPage,
    isLoadMoreVisible,
    isMapAvailable,
    isNoResultsVisible,
    isPickupPointsListLoading,
    pageKey,
    pageNumber,
    pickupPointsList,
    pickupPointsListError,
    searchTerm
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ownerState: {
      isLastPage
    },
    ...getTestIdProps(_models.TestId.PickupPointsListPage),
    children: [isPickupPointsListLoading && (isFirstPage ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.PickupPointsListSkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.DeliveryBoxSkeleton, {})), isFindMessageVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FindPickupPointsSearchMessage.FindPickupPointsSearchMessage, {}), isContentWrapperVisible && /*#__PURE__*/(0, _jsxRuntime.jsxs)(ContentWrapper, {
      children: [isFirstPage && /*#__PURE__*/(0, _jsxRuntime.jsx)(ResultsHeader, {
        ownerState: {
          isMapAvailable
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ResultsLabel, {
          variant: "h6",
          children: resultsLabel
        })
      }), isNoResultsVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NoResultsMessage.NoResultsMessage, {
        searchTerm: searchTerm
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [pickupPointsList?.slice(0, _constants.PICKUP_POINTS_PAGE_SIZE).map(pickupPoint => /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliveryBox.default, {
          boxName: "pickup-point-list-item",
          deliveryItem: pickupPoint,
          isActive: false,
          metaHierarchy: [_models.MetaHierarchy.DeliverySelection, isAddingNewDelivery.current ? _models.MetaHierarchy.FirstSelection : _models.MetaHierarchy.EditSelection, _models.MetaHierarchy.New, _models.MetaHierarchy.PickUpPoint, _models.MetaHierarchy.ListSearch],
          onDeliveryItemActivation: onPickupPointItemConfirmation
        }, pickupPoint.cvId)), isLoadMoreVisible && isLastPage && /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadMore, {
          variant: "outlined",
          onClick: showMorePickupPoints,
          ...getTestIdProps(_models.TestId.LoadMorePickupPoints),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "loadMore"
          })
        })]
      })]
    })]
  });
};
exports.PickupPointsListPage = PickupPointsListPage;